import { createFileRoute, Outlet } from "@tanstack/react-router";
import { DesktopNav } from "@/components/www/desktop-nav";
import { HolidayHoursDialog } from "@/components/www/holiday-hours-dialog";
import { MobileNav } from "@/components/www/mobile-nav";
import { Footer } from "@/components/www/sections/footer";

export const Route = createFileRoute("/_www")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <DesktopNav />
      <Outlet />
      <MobileNav />
      <Footer />
      <HolidayHoursDialog />
    </>
  );
}
